const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  blueColor : '#0158D7',
  darkGrayColor : '#3b3b3b',
  lightGrayColor : '#ebebeb',
  greenColor : '#27b90f'
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"proxima-nova",serif',

  primaryColor: colors.blueColor,
  fontColor: colors.darkGrayColor,
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;